import {createSlice} from '@reduxjs/toolkit'
import IncidentService from '../../api/incident'
import {doNothing} from '../../utils/placeholder'
import FormHelper from '../../utils/forms'
import {toast} from 'react-toastify'

export const phoneCallSlice = createSlice({
    name: 'phone-call',
    initialState: {
        voicesList: [],
        phoneCallTemplates: [],
        isFetching: true
    },
    reducers: {
        setVoicesList: (state, {payload}) => {
            state.voicesList = payload
        },
        setPhoneCallTemplates: (state, {payload}) => {
            state.phoneCallTemplates = payload
        },
        setIsFetching: (state, {payload}) => {
            state.isFetching = payload
        }
    }
})
export const {setVoicesList, setPhoneCallTemplates, setIsFetching} = phoneCallSlice.actions
export default phoneCallSlice.reducer

export const getPhoneCallTemplates = () => {
    return async dispatch => {
        dispatch(setIsFetching(true))
        try {
            const data = await IncidentService.getPhoneCallTemplates()
            dispatch(setPhoneCallTemplates(data?.data?.data))
        } catch (e) {
            doNothing()
        } finally {
            dispatch(setIsFetching(false))
        }
    }
}

export const getAzureVoicesList = () => {
    return async dispatch => {
        try {
            const {data} = await IncidentService.getVoices()
            dispatch(setVoicesList(data?.data?.voices.map(item => ({
                label: item?.display_name || '',
                value: item?.short_name || '',
                locale: item?.locale || '',
                gender: item?.gender || ''
            }))) || [])
        } catch {
            doNothing()
        }
    }
}

export const convertTexttoSpeech = (payload) => {
    return async() => {
        try {
            const {data} = await IncidentService.convertTTS(payload)
            const audioData = data?.data?.audio_data
            return `data:audio/mpeg;base64,${audioData}`
        } catch (e) {
            const res = e?.response?.data
            const message = res?.message
            toast.error(message)
        }
    }
}

export const createNewPhoneCallTemplate = (payload, setFieldError) => {
    return async() => {
        try {
            const {data} = await IncidentService.createPhoneCallTemplate(payload)
            toast.success(data?.message)

            return {success: true}
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)

            return {success: false}
        }
    }
}

export const updatePhoneCallTemplate = (id, payload, setFieldError) => {
    return async() => {
        try {
            const {data} = await IncidentService.updatePhoneCallTemplate(id, payload)
            toast.success(data?.message)

            return {success: true}
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)

            return {success: false}
        }
    }
}

export const deletePhoneCallTemplate = (id) => {
    return async() => {
        try {
            const {data} = await IncidentService.deletePhoneCallTemplate(id)
            toast.success(data?.message)

            return {success: true}
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message)

            return {success: false}
        }
    }
}
